/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignmentResponse,
  AssignmentStatus,
  CreateAssignmentRequest,
  ProblemDetails,
  UpdateAssignmentRequest,
  UpdateAssignmentStatusRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AssignmentResponseFromJSON,
    AssignmentResponseToJSON,
    AssignmentStatusFromJSON,
    AssignmentStatusToJSON,
    CreateAssignmentRequestFromJSON,
    CreateAssignmentRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateAssignmentRequestFromJSON,
    UpdateAssignmentRequestToJSON,
    UpdateAssignmentStatusRequestFromJSON,
    UpdateAssignmentStatusRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateAssignmentOperationRequest {
    createAssignmentRequest: CreateAssignmentRequest;
}

export interface DeleteAssignmentRequest {
    assignmentId: string;
}

export interface GetAllAssignmentsRequest {
    assignedCounselorId?: string;
    status?: AssignmentStatus;
    onlyOverdue?: boolean;
}

export interface GetAssignmentByIdRequest {
    assignmentId: string;
}

export interface UpdateAssignmentOperationRequest {
    assignmentId: string;
    updateAssignmentRequest: UpdateAssignmentRequest;
}

export interface UpdateAssignmentStatusOperationRequest {
    assignmentId: string;
    updateAssignmentStatusRequest: UpdateAssignmentStatusRequest;
}

/**
 * AssignmentsApi - interface
 * 
 * @export
 * @interface AssignmentsApiInterface
 */
export interface AssignmentsApiInterface {
    /**
     * 
     * @param {CreateAssignmentRequest} createAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    createAssignmentRaw(requestParameters: CreateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>>;

    /**
     */
    createAssignment(requestParameters: CreateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    deleteAllCompletedAssignmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAllCompletedAssignments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    deleteAssignmentRaw(requestParameters: DeleteAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteAssignment(requestParameters: DeleteAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} [assignedCounselorId] 
     * @param {AssignmentStatus} [status] 
     * @param {boolean} [onlyOverdue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    getAllAssignmentsRaw(requestParameters: GetAllAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignmentResponse>>>;

    /**
     */
    getAllAssignments(requestParameters: GetAllAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignmentResponse>>;

    /**
     * 
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    getAssignmentByIdRaw(requestParameters: GetAssignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>>;

    /**
     */
    getAssignmentById(requestParameters: GetAssignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse>;

    /**
     * 
     * @param {string} assignmentId 
     * @param {UpdateAssignmentRequest} updateAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    updateAssignmentRaw(requestParameters: UpdateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>>;

    /**
     */
    updateAssignment(requestParameters: UpdateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse>;

    /**
     * 
     * @param {string} assignmentId 
     * @param {UpdateAssignmentStatusRequest} updateAssignmentStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApiInterface
     */
    updateAssignmentStatusRaw(requestParameters: UpdateAssignmentStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>>;

    /**
     */
    updateAssignmentStatus(requestParameters: UpdateAssignmentStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse>;

}

/**
 * 
 */
export class AssignmentsApi extends runtime.BaseAPI implements AssignmentsApiInterface {

    /**
     */
    async createAssignmentRaw(requestParameters: CreateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>> {
        if (requestParameters['createAssignmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createAssignmentRequest',
                'Required parameter "createAssignmentRequest" was null or undefined when calling createAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/assignments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssignmentRequestToJSON(requestParameters['createAssignmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async createAssignment(requestParameters: CreateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse> {
        const response = await this.createAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAllCompletedAssignmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/assignments/completed`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAllCompletedAssignments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllCompletedAssignmentsRaw(initOverrides);
    }

    /**
     */
    async deleteAssignmentRaw(requestParameters: DeleteAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling deleteAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/assignments/{assignmentId}`;
        urlPath = urlPath.replace(`{${"assignmentId"}}`, encodeURIComponent(String(requestParameters['assignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssignment(requestParameters: DeleteAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllAssignmentsRaw(requestParameters: GetAllAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignmentResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['assignedCounselorId'] != null) {
            queryParameters['AssignedCounselorId'] = requestParameters['assignedCounselorId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['Status'] = requestParameters['status'];
        }

        if (requestParameters['onlyOverdue'] != null) {
            queryParameters['OnlyOverdue'] = requestParameters['onlyOverdue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/assignments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssignmentResponseFromJSON));
    }

    /**
     */
    async getAllAssignments(requestParameters: GetAllAssignmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignmentResponse>> {
        const response = await this.getAllAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssignmentByIdRaw(requestParameters: GetAssignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling getAssignmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/assignments/{assignmentId}`;
        urlPath = urlPath.replace(`{${"assignmentId"}}`, encodeURIComponent(String(requestParameters['assignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssignmentById(requestParameters: GetAssignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse> {
        const response = await this.getAssignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAssignmentRaw(requestParameters: UpdateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling updateAssignment().'
            );
        }

        if (requestParameters['updateAssignmentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAssignmentRequest',
                'Required parameter "updateAssignmentRequest" was null or undefined when calling updateAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/assignments/{assignmentId}`;
        urlPath = urlPath.replace(`{${"assignmentId"}}`, encodeURIComponent(String(requestParameters['assignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssignmentRequestToJSON(requestParameters['updateAssignmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAssignment(requestParameters: UpdateAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse> {
        const response = await this.updateAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAssignmentStatusRaw(requestParameters: UpdateAssignmentStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignmentResponse>> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling updateAssignmentStatus().'
            );
        }

        if (requestParameters['updateAssignmentStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAssignmentStatusRequest',
                'Required parameter "updateAssignmentStatusRequest" was null or undefined when calling updateAssignmentStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/assignments/{assignmentId}/status`;
        urlPath = urlPath.replace(`{${"assignmentId"}}`, encodeURIComponent(String(requestParameters['assignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssignmentStatusRequestToJSON(requestParameters['updateAssignmentStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAssignmentStatus(requestParameters: UpdateAssignmentStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignmentResponse> {
        const response = await this.updateAssignmentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
